/** MVT has no numeric wire type, so a numeric column can arrive as a string. */
export function readMvtNumber(value: unknown): number | undefined {
  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}
